import { Item, Collection, timesQty, titlecase } from "./collection_base"
import DataLoader from "#lib/data_loader"

// Gear — a JSON array of { slug, cost, qty, notes } (ordered, dupes allowed).
// Nothing unusual: cost × qty, blob = raw fields.

export class GearItem extends Item {
  // Fill self from the entry: stored controls (cost/qty/notes) + catalog display spans
  // (name/category/description). Moved here from GearCollection#fillItem — same body,
  // now on the item, painting via this.builder().
  async fill(entry) {
    const b = this.builder()
    const c = (await DataLoader.systemGet("gear"))[entry.slug] || {}
    b.fill(entry, { fields: ["cost", "qty", "notes"] })
    b.text("name", c.name || "(unknown)")
    b.text("category", titlecase(c.category))
    b.text("description", c.description)
  }

  // Blob entry from the STASH (not the DOM) — so it serializes correctly regardless of
  // template variant. A fixed key-list; values pass through as stashed (no numeric
  // coercion — a user's raw string is stored verbatim; consumers parse leniently). slug is
  // a Stimulus value, not a stash key.
  entry() {
    return {
      slug: this.slugValue || "",
      id: this.get("id"),
      cost: this.get("cost"),
      qty: this.get("qty"),
      notes: this.get("notes"),
    }
  }

  cost() { return timesQty({ cost: this.get("cost"), qty: this.get("qty") }) }
}

export class GearCollection extends Collection {
  static CATALOGS = ["gear"]

  async newEntry(slug) {
    const c = (await DataLoader.systemGet("gear"))[slug]
    if (!c) return null
    return { slug, cost: c.cost, qty: 1, notes: "" }
  }
}
